import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'


Vue.use(Router)

const routes = [
    {
        path: '/',
        component: resolve => require(['@/views/main.vue'], resolve),
    },
    // 下载
    {
        path: '/DL',
        component: resolve => require(['@/views/download.vue'], resolve),
    },
    // 下载
    {
        path: '/DLM',
        component: resolve => require(['@/views/downloadMan.vue'], resolve),
    },
    // 下载-女性
    {
        path: '/DLW',
        component: resolve => require(['@/views/downloadWoman.vue'], resolve),
    },
    // 二维码推广页
    {
        path: '/QRCode',
        component: resolve => require(['@/views/QRCode.vue'], resolve),
    },
    // 限时邀请活动
    {
        path: '/activity/invite',
        component: resolve => require(['@/views/activity/inviteActivity.vue'], resolve),
    },
    // 问题反馈有奖活动
    {
        path: '/activity/feedback',
        component: resolve => require(['@/views/activity/feedbackActivity.vue'], resolve),
    },
    // 统一活动列表
    {
        path: '/activity/list',
        component: resolve => require(['@/views/activity/activityList.vue'], resolve),
    },
    // 邀请好友活动
    {
        path: '/inviteFriend',
        component: resolve => require(['@/views/activity/inviteFriend.vue'], resolve),
    },
    // 提现奖励活动
    {
        path: '/activity/cashback',
        component: resolve => require(['@/views/activity/cashbackActivity.vue'], resolve),
    },
    // 提现奖励活动（热力开启2，5%-10% 阶梯）
    {
        path: '/activity/cashback2',
        component: resolve => require(['@/views/activity/cashbackActivity2.vue'], resolve),
    },
    /** 协议 **/
    //  隐私协议
    {
        path: '/terms/privacy',
        component: resolve => require(['@/views/terms/privacy.vue'], resolve),
    },
    //  隐私认证
    {
        path: '/terms/privacyAuth',
        component: resolve => require(['@/views/terms/privacyAuth.vue'], resolve),
    },
    // 隐私协议SDK
    {
        path: '/terms/privacySDK',
        component: resolve => require(['@/views/terms/privacySDK.vue'], resolve),
    },
    // 陌撩漂流瓶隐私政策摘要
    {
        path: '/terms/privacyList',
        component: resolve => require(['@/views/terms/privacyList.vue'], resolve),
    },
    //  提现协议
    {
        path: '/terms/withdraw',
        component: resolve => require(['@/views/terms/withdraw.vue'], resolve),
    },
    // 陌撩漂流瓶账号注销协议
    {
        path: '/terms/privacyCancel',
        component: resolve => require(['@/views/terms/privacyCancel.vue'], resolve),
    },
    //  用户协议
    {
        path: '/terms/user',
        component: resolve => require(['@/views/terms/user.vue'], resolve),
    },
    //  充值协议
    {
        path: '/terms/recharge',
        component: resolve => require(['@/views/terms/recharge.vue'], resolve),
    },
    {
        path: '/charts/chartsRegYyb',
        component: resolve => require(['@/views/charts/chartsRegYyb.vue'], resolve),
    },
    // 青少年网页路由
    {
        path: '/teen',
        component: resolve => require(['@/views/teen/TeenIndex.vue'], resolve),
    },
    {
        path: '/teen/0',
        component: resolve => require(['@/views/teen/Teen0.vue'], resolve),
    },
    {
        path: '/teen/1',
        component: resolve => require(['@/views/teen/Teen1.vue'], resolve),
    },
    {
        path: '/teen/2',
        component: resolve => require(['@/views/teen/Teen2.vue'], resolve),
    },
    {
        path: '/teen/3',
        component: resolve => require(['@/views/teen/Teen3.vue'], resolve),
    },
    {
        path: '/teen/4',
        component: resolve => require(['@/views/teen/Teen4.vue'], resolve),
    },
    {
        path: '/teen/5',
        component: resolve => require(['@/views/teen/Teen5.vue'], resolve),
    },
    {
        path: '/teen/6',
        component: resolve => require(['@/views/teen/Teen6.vue'], resolve),
    },
    {
        path: '/teen/7',
        component: resolve => require(['@/views/teen/Teen7.vue'], resolve),
    },
    {
        path: '/teen/8',
        component: resolve => require(['@/views/teen/Teen8.vue'], resolve),
    },
    {
        path: '/teen/9',
        component: resolve => require(['@/views/teen/Teen9.vue'], resolve),
    },
    {
        path: '/teen/10',
        component: resolve => require(['@/views/teen/Teen10.vue'], resolve),
    },
    {
        path: '/teen/11',
        component: resolve => require(['@/views/teen/Teen11.vue'], resolve),
    },
    {
        path: '/teen/12',
        component: resolve => require(['@/views/teen/Teen12.vue'], resolve),
    },
    {
        path: '/teen/13',
        component: resolve => require(['@/views/teen/Teen13.vue'], resolve),
    },
    {
        path: '/teen/14',
        component: resolve => require(['@/views/teen/Teen14.vue'], resolve),
    },
];


// 创建路由器
const router = new Router({
    routes
});

router.beforeEach((to, from, next) => {
    next();
    store.dispatch('editableTabs/worktabRoute', {
        to: {
            name: to.name ? to.name : '',
            tabname: (to.meta && to.meta.tabname) ? to.meta.tabname : '',
            path: to.path
        },
        from: {
            name: from.name ? from.name : '',
            tabname: (from.meta && from.meta.tabname) ? from.meta.tabname : '',
            path: from.path
        }
    });
});

export default router
